<template>
  <v-container fluid>
    <v-card class="flex">
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-card>
              <v-text-field v-model="searchText" hide-details
                label="Search for users based on email, forename or surname. Type at least three characters and hit the Enter key"
                class="ma-2 pa-2" v-on:keyup.enter="performUserSearch" append-icon="mdi-magnify"
                @click:append="performUserSearch">
              </v-text-field>
            </v-card>
          </v-col>
        </v-row>
        <div v-if="userList && !selectedUser">
          <user-table :users="userList" v-on:userSelected="selectUser" />
        </div>
        <v-row v-if="selectedUser">
          <v-col cols="12">

            <v-tabs style="max-width:100%">
              <v-tab dense v-for="tab in userAdminFunctions" :key="tab.adminFunction" class="align-left">
                <v-icon left> {{ tab.icon }} </v-icon>
                {{ tab.adminFunction }}
              </v-tab>
              <v-spacer />
              <v-tab-item key="User Stats">
                <user-activity :user="selectedUser" />
              </v-tab-item>
              <v-tab-item key="Update User Details">
                <user-form :user="selectedUser" />
              </v-tab-item>
            </v-tabs>

          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import serverFunctions from "@/functions/serverFunctions";
import userFunctions from "@/functions/userFunctions";
import UserForm from "../components/UserForm";
import UserTable from "../components/UserTable";
import UserActivity from "../components/UserActivity";

export default {
  components: {
    "user-form": UserForm,
    "user-table": UserTable,
    "user-activity": UserActivity,
  },
  data: () => ({
    userList: null,
    searchText: null,
    selectedUser: null,
    userAdminFunctions: [
      { adminFunction: "User Stats", icon: "mdi-table" },
      { adminFunction: "Update User Details", icon: "mdi-account" },
    ],
  }),
  methods: {
    selectUser(user) {
      this.selectedUser = user;
    },
    async performUserSearch() {

      this.selectedUser = null;
      if (this.searchText.length < 3) {
        alert('Type at least 3 characters, then search')
        this.userList = null;
        return;
      }
      this.$router.push({ name: 'SiteAdminSearch', params: { search: this.searchText } })
      this.getSearchResults();

    },
    async getSearchResults() {

      let userSearchRequest = serverFunctions.getUserSearchRequest(
        userFunctions.getLoggedInUser(),
        this.searchText
      );

      this.userList = await serverFunctions.getPostResponse(
        "/userSearch",
        userSearchRequest
      );

    }
  },
  beforeMount() {
    if (this.$route.params.search) {
      this.searchText = this.$route.params.search
      this.getSearchResults();
    }
  }
};
</script>

<style scoped>
.white-text {
  color: white;
}
</style>
